<template>
  <div>
    <!-- 原始图片 -->
    <img
        :src="imageSrc"
        :alt="alt"
        @click="openModal"
        class="image-thumbnail"
    />

    <!-- 放大查看的 Modal -->
    <div v-if="isModalOpen" class="modal-overlay" @click="closeModal">
      <div class="modal-content" @click.stop>
        <img :src="imageSrc" :alt="alt" class="modal-image" />
        <button class="close-btn" @click="closeModal">X</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageViewer',
  props: {
    imageSrc: {
      type: String,
      required: true
    },
    alt: {
      type: String,
      default: 'Image'
    }
  },
  data() {
    return {
      isModalOpen: false
    };
  },
  methods: {
    openModal() {
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
    }
  }
};
</script>

<style scoped>
/* 图片缩略图样式 */
.image-thumbnail {
  width: 100px;
  height: 100px;
  object-fit: cover;
  cursor: pointer;
  transition: transform 0.3s;
}

.image-thumbnail:hover {
  transform: scale(1.1);
}

/* 模态框覆盖层 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

/* 模态框内容 */
.modal-content {
  position: relative;
  max-width: 80%;
  max-height: 80%;
}

/* 放大后的图片样式 */
.modal-image {
  width: 100%;
  height: auto;
  object-fit: contain;
}

/* 关闭按钮样式 */
.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  padding: 5px 10px;
  cursor: pointer;
}

.close-btn:hover {
  background: rgba(0, 0, 0, 0.7);
}
</style>
